import Vue from 'vue'
import money from 'v-money'
import i18n from './i18n'

const locale = i18n.locale;
const { decimal, thousands, prefix } = locale === 'pt' ? { decimal: ',', thousands: '.', prefix: 'R$ ' } : { decimal: '.', thousands: ',', prefix: '$ ' };

Vue.use(money, {
    decimal: decimal,
    thousands: thousands,
    prefix: prefix,
    suffix: '',
    precision: 2,
    masked: false
})